import React, { useState } from "react";
import "./Faq.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { FiPlus, FiMinus } from "react-icons/fi";
import { FiHeadphones } from "react-icons/fi";
import bannerImg from "../../assets/images/faq1.png";
import { FiSearch } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const faqData = {
  "Brand, App & Credentials": [
    {
      question: "Do Astro Logical Solutions have an app?",
      answer:
        "Yes. The Astro Logical Solutions Rudraksha mobile app is available for easy order tracking, viewing Pooja videos, accessing digital certificates, and enjoying Exclusive Sadhana Access. It's designed to make your spiritual journey more accessible and seamless.",
    },
  ],

  "Care, Maintenance & Longevity": [
    {
      question: "Is it safe to wear Rudraksha while sleeping or showering?",
      answer:
        "While it's not harmful, it's advised to remove your Rudraksha during bathing or sleeping to maintain its spiritual energy and protect it from physical damage, especially capped malas. Avoid exposing it to soap, shampoo, and harsh chemicals.",
    },
  ],
  "Customer Support & Consultation": [
    {
      question: "How do I know which Rudraksha to buy?",
      answer:
        "Use our Personalized Recommendation Tool by entering your date, time, and place of birth to receive the most suitable Rudraksha suggestions. You can also connect with our spiritual experts for one-on-one guidance before making your purchase.",
    },
    {
      question: "Do Astro Logical Solutions provide spiritual consultations?",
      answer:
        "Yes. Our experienced spiritual advisors provide personalized consultations based on your goals, horoscope, and life concerns. Whether you're seeking better health, career growth, peace of mind, or spiritual progress, we'll help you choose the most appropriate Rudraksha.",
    },
    {
      question: "How can I contact support of Astro Logical Solutions?",
      answer:
        "You can reach our customer support team through phone, WhatsApp, email, or the Contact Us page on our website. Our team is available to assist you with product recommendations, order tracking, certification queries, and after-sales support.",
    },
    {
      question: "What details do I need to get a Rudraksha recommendation?",
      answer:
        "For the most accurate recommendation, please provide your full date of birth, exact birth time, and birthplace. If these details are unavailable, our experts can still suggest suitable Rudraksha options based on your concerns and spiritual objectives.",
    },
    {
      question:
        "Does Astro Logical Solutions offer horoscope/Kundali matching?",
      answer:
        "Yes. We offer horoscope (Kundali) analysis and guidance to help determine the most beneficial Rudraksha for your planetary positions and personal aspirations. Consultation may be available as a complimentary or premium service depending on your requirements.",
    },
    {
      question:
        "Can I talk to someone from Astro Logical Solutions before purchasing?",
      answer:
        "Absolutely. Our support and consultation team is happy to answer your questions before you place an order. You can discuss product selection, authenticity, sizing, combinations, and any spiritual guidance you may need to make a confident purchase.",
    },
  ],

  "Energization & Transformation": [
    {
      question: "Does Astro Logical Solutions provide energization?",
      answer:
        "Yes. Every Rudraksha from Astro Logical Solutions undergoes a traditional Prana Sparsha (touch energization) ritual at the sacred Pashupatinath Temple before dispatch. For those seeking a more elaborate Vedic ritual, Prana Pratishtha Energization is also available as an optional premium service.",
    },
  ],

  "Product & Authenticity": [
    {
      question:
        "What types of Rudraksha products are available at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers a wide range of authentic Rudraksha products, including single beads (1 Mukhi to 21 Mukhi), malas, bracelets, pendants, Siddha Malas, spiritual jewelry, and customized combinations designed for different spiritual and astrological purposes.",
    },
    {
      question:
        "Where are the Rudraksha sourced from at Astro Logical Solutions?",
      answer:
        "Our Rudraksha beads are primarily sourced from the Himalayan regions of Nepal, known for producing high-quality and naturally formed Rudraksha. Every bead is carefully selected and inspected before being offered to customers.",
    },
    {
      question:
        "Are the Rudraksha beads from Astro Logical Solutions authentic and natural?",
      answer:
        "Yes. Every Rudraksha sold by Astro Logical Solutions is 100% natural, genuine, and thoroughly examined for authenticity. We ensure that our customers receive only high-quality, untreated Rudraksha beads.",
    },
    {
      question:
        "Do all Rudraksha products from Astro Logical Solutions come with a certificate?",
      answer:
        "Yes. Most of our Rudraksha products are accompanied by an authenticity certificate. Selected premium Rudraksha also include advanced laboratory or X-ray certification for additional verification.",
    },
    {
      question: "Why should one wear Rudraksha?",
      answer:
        "Rudraksha is traditionally believed to promote peace of mind, spiritual growth, mental clarity, emotional balance, and protection from negative energies. Many people also wear it for meditation, personal well-being, and astrological benefits.",
    },
    {
      question: "What does the X-Ray certification prove?",
      answer:
        "An X-ray certificate confirms the internal structure and natural compartments (mukhis) of the Rudraksha bead. It provides additional assurance that the bead is genuine and has not been artificially modified.",
    },
    {
      question: "Are Astro Logical Solutions Rudrakshas tamper-proof?",
      answer:
        "Yes. Every Rudraksha undergoes a strict quality inspection before dispatch. We ensure that the beads are natural and free from artificial alterations, providing customers with authentic and trustworthy products.",
    },
  ],

  "Wearing Rudraksha": [
    {
      question: "Is it safe to wear Rudraksha while sleeping or showering?",
      answer:
        "While it is generally safe to wear Rudraksha, it is recommended to remove it while bathing or sleeping. This helps protect the bead from soap, chemicals, excess moisture, and physical damage, ensuring its longevity and spiritual purity.",
    },
    {
      question: "Are there any restrictions while wearing Rudraksha?",
      answer: (
        <>
          <p>
            To maintain the sanctity and effectiveness of your Rudraksha, we
            recommend following these traditional practices:
          </p>

          <ul>
            <li>
              Remove it before bathing to avoid contact with soap and chemicals.
            </li>
            <li>Do not soak the Rudraksha in milk, ghee, or other liquids.</li>
            <li>Avoid wearing it during intimate activities.</li>
            <li>
              If it becomes wet, dry it naturally and apply a small amount of
              natural oil occasionally.
            </li>
            <li>
              Handle the Rudraksha with clean hands and store it in a clean,
              sacred place when not in use.
            </li>
          </ul>

          <p>
            These are traditional recommendations intended to preserve the
            Rudraksha's spiritual energy and physical condition.
          </p>
        </>
      ),
    },
    {
      question: "Can anyone wear Rudraksha?",
      answer:
        "Yes. Rudraksha can be worn by people of all ages, genders, and backgrounds. It is regarded as a sacred bead that supports meditation, spiritual growth, and overall well-being.",
    },
    {
      question: "Can I wear more than one Rudraksha at the same time?",
      answer:
        "Yes. Multiple Rudraksha beads can be worn together, provided they are chosen according to your spiritual goals or expert guidance. Certain combinations are believed to provide enhanced benefits.",
    },
    {
      question: "Which day is best to start wearing Rudraksha?",
      answer:
        "Monday is traditionally considered the most auspicious day to begin wearing Rudraksha, especially after offering prayers to Lord Shiva. However, it may also be worn on other spiritually significant days.",
    },
    {
      question: "How should I wear my Rudraksha?",
      answer:
        "Rudraksha can be worn as a mala, bracelet, pendant, or in a combination recommended by our experts. It should be worn with faith, respect, and kept clean for the best spiritual experience.",
    },
  ],

  "Payments, Security & Cancellation": [
    {
      question:
        "Do Astro Logical Solutions accept international payment methods like credit cards and PayPal?",
      answer:
        "Yes. We accept major international payment methods, including Visa, MasterCard, American Express, PayPal, and bank transfers. For customers in India, we also support UPI, net banking, debit cards, credit cards, and popular digital wallets for a secure checkout experience.",
    },
    {
      question: "Can I shop in different currencies?",
      answer:
        "Yes. Our website supports multiple currencies for the convenience of international customers. The final payment amount is calculated based on the selected currency and your payment provider's exchange rate, where applicable.",
    },
    {
      question: "Is my payment information secure?",
      answer:
        "Absolutely. We use industry-standard SSL encryption and trusted payment gateways to protect your personal and financial information. Your payment details are processed securely and are never stored on our servers.",
    },
    {
      question: "Can I cancel my order after making the payment?",
      answer:
        "Yes. Orders can usually be cancelled before they are processed or shipped. If your order has already been dispatched, cancellation may not be possible. Please contact our customer support team as soon as possible for assistance.",
    },
    {
      question: "Will I receive a payment confirmation?",
      answer:
        "Yes. Once your payment is successfully completed, you will receive an order confirmation and payment receipt via email and/or WhatsApp, along with your order details.",
    },
  ],

  "Pricing, Offers & Customization": [
    {
      question:
        "Why are the prices higher compared to other sellers at Astro Logical Solutions?",
      answer:
        "Our prices reflect the authenticity, premium quality, and careful sourcing of every Rudraksha. Each bead undergoes strict quality checks, is accompanied by authenticity certification where applicable, and is backed by expert guidance and reliable customer support, ensuring you receive genuine spiritual products.",
    },
    {
      question: "What is the price range of Astro Logical Solutions products?",
      answer:
        "We offer products across a wide price range to suit different budgets and spiritual needs. Prices vary depending on the Mukhi, rarity, size, origin, certification, and craftsmanship of the Rudraksha or spiritual accessory.",
    },
    {
      question: "Are there any discounts or offers?",
      answer:
        "Yes. Astro Logical Solutions regularly offers seasonal discounts, festive promotions, exclusive app offers, and special deals on selected products. Visit our website or subscribe to our newsletter to stay updated with the latest offers.",
    },
    {
      question: "What are customization charges?",
      answer:
        "Customization charges depend on the type of customization requested, such as premium capping, custom bracelets, personalized malas, pendants, or special packaging. The exact cost is shared before your order is confirmed.",
    },
    {
      question: "Can I request a customized Rudraksha bracelet or mala?",
      answer:
        "Yes. We offer customized Rudraksha bracelets, malas, pendants, and combination sets based on your preferences or our experts' recommendations. Additional charges may apply depending on the materials and design.",
    },
  ],

  "Astro Logical Solutions Brand": [
    {
      question:
        "Why do customers trust Astro Logical Solutions for genuine Rudraksha beads?",
      answer:
        "Customers trust Astro Logical Solutions because of our commitment to authenticity, ethical sourcing, rigorous quality checks, and transparent certification process. Every Rudraksha is carefully inspected before dispatch, ensuring our customers receive genuine and spiritually significant products.",
    },
    {
      question: "What is the AAA Quality Standard?",
      answer:
        "The AAA Quality Standard represents our highest level of product quality. Rudraksha beads meeting this standard are selected based on their natural shape, well-defined mukhis, durability, appearance, and overall authenticity to ensure premium quality.",
    },
    {
      question: "Is Astro Logical Solutions ISO certified?",
      answer:
        "Yes. Astro Logical Solutions follows internationally recognized quality management practices. Our commitment to quality, authenticity, and customer satisfaction is reflected in our certifications and standardized business processes.",
    },
    {
      question: "Who is the Astro Logical Solutions brand ambassador?",
      answer:
        "Astro Logical Solutions collaborates with respected spiritual leaders, wellness experts, and public personalities to promote awareness about authentic Rudraksha. For the latest information regarding official brand ambassadors, please refer to our website or social media channels.",
    },
    {
      question:
        "What makes Astro Logical Solutions different from other brands?",
      answer:
        "Astro Logical Solutions stands out through authentic Nepal-sourced Rudraksha, strict quality control, expert spiritual guidance, authenticity certification, worldwide shipping, and dedicated customer support. Our focus is to provide genuine spiritual products with complete transparency and trust.",
    },
  ],

  "Returns, Damage & After-Sales": [
    {
      question: "What if my Rudraksha gets damaged during shipping?",
      answer:
        "We take great care in packaging every order to ensure safe delivery. If your Rudraksha arrives damaged, please contact our customer support within 48 hours of receiving the package and share clear photos of the product and packaging. After verification, we will arrange a replacement or provide a suitable resolution according to our return policy.",
    },
    {
      question: "What if a Rudraksha breaks over time?",
      answer:
        "Rudraksha is a natural bead, and with proper care it can last for many years. If your Rudraksha develops damage due to manufacturing defects within the applicable warranty period, please contact our support team for evaluation. Damage caused by accidental impact, improper handling, or normal wear may not be covered.",
    },
    {
      question: "How do I initiate a return or refund?",
      answer:
        "To request a return or refund, simply contact our customer support team with your order number and the reason for your request. Once your request is reviewed and approved according to our return policy, we'll guide you through the return process and keep you updated until it is completed.",
    },
    {
      question: "How long does it take to process a refund?",
      answer:
        "Approved refunds are generally processed within 5–10 business days. The exact time may vary depending on your original payment method and your bank or payment provider.",
    },
    {
      question: "Do you provide after-sales support?",
      answer:
        "Yes. Our dedicated after-sales support team is available to assist you with product care, authenticity queries, maintenance guidance, warranty-related concerns, replacements, and any issues you may experience after your purchase.",
    },
  ],
};

function Refund() {
  const categories = Object.keys(faqData);

  const [activeCategory, setActiveCategory] = useState(categories[0]);
  const [openIndex, setOpenIndex] = useState(0);

  const handleCategory = (category) => {
    setActiveCategory(category);
    setOpenIndex(0);
  };

  return (
    <>
      <Helmet>
        {/* Meta Title */}
        <title>
          Astrology FAQ: Vastu, Numerology & Rudraksha Answers | Astro
        </title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Find answers to common questions about astrology, Vastu, numerology, Rudraksha, gemstones and spiritual remedies with Astro Logical Solutions."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://astrologicalsolutions.in/faq" />

        {/* Robots */}
        <meta name="robots" content="index, follow, max-image-preview:large" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta
          property="og:title"
          content="Astrology FAQ: Vastu, Numerology & Rudraksha Answers | Astro"
        />

        <meta
          property="og:description"
          content="Find answers to common questions about astrology, Vastu, numerology, Rudraksha, gemstones and spiritual remedies."
        />

        <meta
          property="og:url"
          content="https://astrologicalsolutions.in/faq"
        />

        <meta property="og:site_name" content="Astro Logical Solutions" />

        <meta
          property="og:image"
          content="https://astrologicalsolutions.in/og/faq-banner.jpg"
        />

        <meta
          property="og:image:alt"
          content="Frequently asked questions about astrology, Vastu and Rudraksha"
        />

        <meta property="og:locale" content="en_IN" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Astrology FAQ: Vastu, Numerology & Rudraksha Answers | Astro"
        />

        <meta
          name="twitter:description"
          content="Find answers to common questions about astrology, Vastu, numerology, Rudraksha, gemstones and spiritual remedies."
        />

        <meta
          name="twitter:image"
          content="https://astrologicalsolutions.in/og/faq-banner.jpg"
        />

        {/* FAQ Page Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            url: "https://astrologicalsolutions.in/faq",
            name: "Astrology FAQ: Vastu, Numerology & Rudraksha Answers | Astro",
            description:
              "Find answers to common questions about astrology, Vastu, numerology, Rudraksha, gemstones and spiritual remedies.",
            mainEntity: Object.values(faqData)
              .flat()
              .map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: typeof faq.answer === "string" ? faq.answer : undefined,
                },
              }))
              .filter((faq) => faq.acceptedAnswer.text),
          })}
        </script>
      </Helmet>

      <Header />
      <section className="faq-banner">
        <img src={bannerImg} alt="FAQ Banner" className="faq-banner-img" />

        <div className="faq-overlay">
          <h1>Frequently Asked Question</h1>

          <p>
            Find answers to the most commonly asked questions below. Search for
            topics you're interested in or sort by category.
          </p>

          <div className="faq-search">
            <input type="text" placeholder="Search for a Question" />
            <FiSearch className="search-iconv" />
          </div>
        </div>
      </section>
      <div className="astroFaq-section">
        <div className="astroFaq-category-grid">
          {categories.map((item) => (
            <button
              key={item}
              className={`astroFaq-category-btn ${
                activeCategory === item ? "active" : ""
              }`}
              onClick={() => handleCategory(item)}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="astroFaq-list">
          {faqData[activeCategory].map((faq, index) => (
            <div className="astroFaq-item" key={index}>
              <div
                className="astroFaq-question"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h4>{faq.question}</h4>

                {openIndex === index ? (
                  <FiMinus size={20} />
                ) : (
                  <FiPlus size={20} />
                )}
              </div>

              {openIndex === index && (
                <div className="astroFaq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <section className="support-section">
        <div className="support-content">
          <h2>Need Support? Get Consultation Now!</h2>

          <p>Need to chat with us? We are happy to assist you.</p>

        <Link to="/contact" className="support-btn">
  <FiHeadphones />
  Get Support
</Link>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Refund;
